import React from 'react';
import {LauncherLayout} from "../layout/LauncherLayout";
import {OauthLoginButton} from "./OauthLoginButton";

export interface OauthLoginProps {
    redirectLocation?: string;
}

export const OauthLoginPage: React.FC<OauthLoginProps> = (props) => {

    return (
        <LauncherLayout>
            <OauthLoginButton {...props} />
        </LauncherLayout>
    );
}